export default {
  namespaced: true,
  actions: {
    async register({ dispatch }, { payload }) {
      payload.type = 'users'
      try {
        const student = await this._vm.$axios.post(
          '/api/students/signup',
          payload
        )
        dispatch('entities/users/insert', { data: student }, { root: true })
        return student
      } catch (error) {
        throw error
      }
    },
    async login({ _dispatch }, { payload }) {
      try {
        const accessToken = await this._vm.$axios.post(
          '/api/students/oauth/token',
          {
            username: payload.username,
            password: payload.password
          }
        )
        return accessToken
      } catch (error) {
        throw error
      }
    },
    async resetPassword({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/students/reset-password', payload)
        return true
      } catch (error) {
        throw error
      }
    },
    async forgotPassword({ _dispatch }, { payload }) {
      payload.type = 'user'
      try {
        await this._vm.$axios.post('/api/students/forgot-password', {
          username: payload.email,
          type: 'user'
        })

        return true
      } catch (error) {
        throw error
      }
    },
    async updateStudentInfo({ _dispatch }, { payload }) {
      try {
        let data = {
          // name: payload.name,
          email: payload.email,
          id: payload.id,
          classInvitationId: payload.classInvitationId
        }
        if (payload.password) data['password'] = payload.password
        await this._vm.$axios.patch(`/api/teacher/students/${payload.id}`, data)

        return true
      } catch (error) {
        throw error
      }
    },
    async sendSupportEmail({ _dispatch }, { payload }) {
      try {
        let data = {
          question_type: payload.question_type,
          message: payload.message,
          isSDECC: 1,
          phone: payload.phone
        }
        await this._vm.$axios.post('/api/students/supports', data)

        return true
      } catch (error) {
        throw error
      }
    }
  }
}
